import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Dziękujemy za Twoją ocenę!',
  text: 'Czy jest coś co możemy poprawić? Podziel sie z nami swoją opinią.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Twoja opinia...'
      }
    ],
    submit: {
      label: 'Wyślij'
    }
  }
};
